import { client } from "../client";
/**
 * Triggered when the music search bar is changed
 * @param {MouseEvent} event
 */
export function chartable_filter(_event: Event) {
  const searchname = (<HTMLInputElement>(
    document.getElementById("client_charactersearch")
  )).value;

  client.chars.forEach((character: any, charid: number) => {
    const demothing = document.getElementById(`demo_${charid}`)!;
    const entry = document.getElementById(`charlist_${charid}`);
    const match =
      character.name.toLowerCase().indexOf(searchname.toLowerCase()) !== -1;
    demothing.style.display = match ? "inline-block" : "none";
    if (entry) entry.style.display = match ? "" : "none";
  });
}
window.chartable_filter = chartable_filter;
